module.exports = __webpack_public_path__ + "static/media/merge-update.b9a802bc.png";